import styled, { css } from "styled-components";

interface TabItemStyleProps {
  $active?: boolean;
}

export const TabItem = styled.li`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: center;
`;

export const TabItemTit = styled.div<TabItemStyleProps>`
  height: 50px;
  color: ${(props) => props.theme.colors.text2};
  font-size: 1.4rem;
  line-height: 50px;

  ${(props) =>
    props.$active === true &&
    css`
      color: ${props.theme.colors.primary100};
      font-weight: 800;
      border-bottom: 2px solid ${props.theme.colors.primary100};
    `}
`;
